/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_Import_Csv_Validation_FileInputs */



/**
* | output |
* | --- |
* | "Choose a CSV file to import." |
*
* @param {Datasets_Import_Csv_Validation_FileInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_import_csv_validation_file = /** @type {((inputs?: Datasets_Import_Csv_Validation_FileInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Import_Csv_Validation_FileInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie eine CSV-Datei zum Importieren aus.")
	return /** @type {LocalizedString} */ ("Choose a CSV file to import.")
});